import { Grid2, useMediaQuery, useTheme } from '@mui/material';
import FormFields from 'pages/components/FormFields';
import Section from 'pages/components/Section';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';

import { Tooltip } from '@mui/material';
import { CreatePaymentPlanRequest } from 'Domain/PaymentPlan/Dto/CreatePaymentPlanRequest';
import { PaymentPlanConfig } from 'Domain/PaymentPlan/Helper/PaymentsCalculator';
import { formatPrice, getDateFormat } from 'pages/Utils/Formats';

import { getCurrentUserData } from 'Application/User/UserService';

const color = 'white';
const textColor = 'gray';

export default function PaymentPlanForm(props: any) {
  const {
    handleInputChange,
    values,
    errors,
    formatErrorObject,
    options,
    disableNumberOfSequences,
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  return (
    <Grid2 width={'100%'} gap={2} display="grid">
      <Section title={'create_payment_plan'}>
        <Grid2 width={'100%'} gap={2} display="grid">
          <FormFields.TextInput
            name="quote"
            value={values.quote}
            onChange={handleInputChange}
          />

          <FormFields.Price
            autoFocus
            name="financedAmount"
            value={values.financedAmount}
            onChange={handleInputChange}
            {...formatErrorObject(errors.financedAmount)}
          />

          <Grid2
            display={'grid'}
            gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr'}
            gap={2}
            container
          >
            <FormFields.Price
              name="initialAmount"
              value={values.initialAmount}
              onChange={handleInputChange}
              {...formatErrorObject(errors.initialAmount)}
            />

            <FormFields.InlineSelect
              name="numberOfSequences"
              options={options.numberOfSequences.map(
                (option: any) => option.value,
              )}
              value={values.numberOfSequences}
              onChange={handleInputChange}
              disabled={disableNumberOfSequences}
            />
          </Grid2>
        </Grid2>
      </Section>

      <Section title={'options'}>
        <Grid2
          width={'100%'}
          display={'grid'}
          gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr'}
          gap={2}
          container
        >
          {!isSecuredActive() ? (
            <Tooltip
              title={t('FEATURE.payment_plan_secured_limited')}
              sx={{
                backgroundColor: color,
                color: textColor,
              }}
              placement="top"
              arrow={true}
            >
              <div>
                <FormFields.Switch
                  name="secured"
                  size="large"
                  disabled={true}
                  value={values.secured}
                  onChange={handleInputChange}
                />
              </div>
            </Tooltip>
          ) : (
            <FormFields.Switch
              name="secured"
              size="large"
              disabled={false}
              value={values.secured}
              onChange={handleInputChange}
            />
          )}

          {false && (
            // (
            <FormFields.InlineSelect
              name="numberOfSessions"
              disabled={!values.secured}
              options={options.numberOfSessions.map(
                (option: any) => option.value,
              )}
              disabledOptions={options.numberOfSessions
                .filter((option: any) => option.value > 2)
                .map((option: any) => ({
                  value: option.value,
                  info: t('FEATURE.coming_soon'),
                }))}
              shape={'circular'}
              value={values.numberOfSessions}
              onChange={handleInputChange}
            />
          )}
          {false && <SecurityChecksInfo values={values} />}
        </Grid2>
      </Section>
    </Grid2>
  );
}

function SecurityChecksInfo({ values }: any) {
  const { t } = useTranslation();
  const paymentPlanConfig = new PaymentPlanConfig(
    new CreatePaymentPlanRequest(
      '',
      values.quote,
      values.financedAmount,
      values.initialAmount,
      values.numberOfSequences,
      values.numberOfSessions,
      values.secured,
    ),
  );
  const securityChecksData = paymentPlanConfig.getSecurityChequeData();

  if (!securityChecksData) {
    return <></>;
  }
  const info = (
    <pre>
      {securityChecksData &&
        t('CONTENT.security_checks', {
          checksNumber: securityChecksData.number,
          checksAmount: formatPrice(securityChecksData.amount),
          checksDate: securityChecksData.date.format(getDateFormat()),
        })}
    </pre>
  );

  return (
    <Tooltip
      title={info}
      sx={{
        backgroundColor: color,
        color: textColor,
      }}
      placement="top"
      arrow={true}
    >
      <InfoIcon />
    </Tooltip>
  );
}

function isSecuredActive() {
  const user = getCurrentUserData();
  return user.userData.email.toLowerCase() === 'jps.mycareflex@gmail.com';
}
